"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeCarousel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("@completeanatomy/ui");
const molecules_1 = require("../../molecules");
const bridge_1 = require("@completeanatomy/bridge");
const analytics_1 = require("@completeanatomy/analytics");
function ModeCarousel({ children = [], type, showImage = false, }) {
    var _a, _b;
    const defaultSelected = Math.max(0, (_a = children === null || children === void 0 ? void 0 : children.findIndex(item => item.isSelected)) !== null && _a !== void 0 ? _a : 0);
    const carouselRef = (0, react_1.useRef)(null);
    const bridge = (0, bridge_1.useBridge)();
    const analytics = (0, analytics_1.useAnalytics)();
    const selectedIndex = children === null || children === void 0 ? void 0 : children.findIndex((item) => item.isSelected);
    (0, react_1.useEffect)(() => {
        var _a;
        if (selectedIndex === -1) {
            return;
        }
        (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.select(selectedIndex);
    }, [selectedIndex]);
    const sendAnalyticsEvent = (index) => {
        const segmentation = {
            name: children[index].title,
            toolType: type,
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        };
        analytics.log('InfoboxItemSelected', segmentation);
    };
    const onSelect = (index) => {
        sendAnalyticsEvent(index);
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
            type,
            index,
            identifier: children[index].identifier,
        });
    };
    return ((0, jsx_runtime_1.jsx)(ui_1.Carousel, { defaultSelected: defaultSelected, ref: carouselRef, onSelect: onSelect, "data-e2e": 'ModeCarousel_Carousel', children: (_b = children === null || children === void 0 ? void 0 : children.map((item, i) => ((0, jsx_runtime_1.jsx)(molecules_1.CarouselCard, Object.assign({ showImage: showImage }, item, { "data-e2e": 'ModeCarousel_CarouselCard' }), i)))) !== null && _b !== void 0 ? _b : [] }));
}
exports.ModeCarousel = ModeCarousel;
